import React from 'react';
import { useRewards } from '../context/RewardsContext';

const REWARDS = [
  { key: 'goldCoins', icon: '🪙', label: 'Gold Coins' },
  { key: 'quantumShards', icon: '🧩', label: 'Quantum Shards' },
  { key: 'galaxyKeys', icon: '🗝️', label: 'Galaxy Keys' },
  { key: 'researchPoints', icon: '🧠', label: 'Research Points' },
  { key: 'timePod', icon: '⏳', label: 'Time Pod' },
  { key: 'cosmeticCollectibles', icon: '🤖', label: 'Cosmetics' },
];

const numberFormatter = new Intl.NumberFormat();

export default function RewardsPanel() {
  const { wallet, isLoading, error, refresh, isLocalFallback } = useRewards();

  return (
    <section
      aria-labelledby="reward-vault-title"
      className="rounded-3xl border border-indigo-100 bg-white p-5 shadow-sm sm:p-6"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <h2 id="reward-vault-title" className="text-xl font-black text-slate-900">
              Reward Vault
            </h2>
            {isLocalFallback && (
              <span className="rounded-full bg-amber-100 px-2.5 py-1 text-xs font-bold text-amber-800">
                Local preview · not synced
              </span>
            )}
          </div>
          <p className="mt-1 text-sm text-slate-500">
            Your current CascadeJoy reward balances.
          </p>
        </div>

        <button
          type="button"
          onClick={refresh}
          disabled={isLoading}
          className="self-start rounded-xl border border-slate-200 bg-white px-3.5 py-2 text-sm font-bold text-slate-700 transition hover:border-indigo-200 hover:bg-indigo-50 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isLoading ? 'Refreshing…' : 'Refresh'}
        </button>
      </div>

      {error && (
        <div role="alert" className="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-800">
          {error}
        </div>
      )}

      <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-7">
        {REWARDS.map((reward) => {
          const balance = wallet?.[reward.key] ?? 0;
          const isBalanceUnavailable = !wallet;

          return (
            <article key={reward.key} className="rounded-2xl border border-slate-200 bg-slate-50 p-4">
              <div className="text-2xl" aria-hidden="true">{reward.icon}</div>
              <p className="mt-3 text-2xl font-black tabular-nums text-slate-900">
                {isBalanceUnavailable ? '—' : numberFormatter.format(balance)}
              </p>
              <p className="mt-1 text-xs font-bold leading-snug text-slate-500">{reward.label}</p>
            </article>
          );
        })}
      </div>
    </section>
  );
}
